import { useState, useEffect, memo, useRef } from 'react';
import { object, bool, string, oneOfType, func } from 'prop-types';
import { getAllFontStyles } from '../../../../helpers/utils';
import { getTextWidth } from '../../../../helpers/document-utils';
const DATE_FORMATS = ['date.formats.search_date', 'date.formats.short_date_month'];
const DATE_DEFAULT_FORMAT = 'date.formats.schedule_date';
const ResponsiveValue = ({
  value,
  isRange,
  children
}) => {
  const ref = useRef(null);
  // initial value for SSR rendering
  const [preparedValue, setValue] = useState();
  const setValueBasedOnInputsWidth = ({
    from,
    to,
    date
  }) => {
    const computedStyle = getComputedStyle(ref.current);
    const offsetPadding = parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
    const width = ref.current.clientWidth - offsetPadding;
    const font = getAllFontStyles(ref.current);
    const currentFormatKey = DATE_FORMATS.find(formatKey => {
      const textWidth = getTextWidth({
        font,
        text: isRange ? `${I18n.l(formatKey, from)} - ${to ? I18n.l(formatKey, to) : ''}` : I18n.l(formatKey, date)
      });
      return width > textWidth;
    }) || DATE_DEFAULT_FORMAT;
    return isRange ? `${I18n.l(currentFormatKey, from)} - ${to ? I18n.l(currentFormatKey, to) : ''}` : I18n.l(currentFormatKey, date);
  };
  useEffect(() => {
    if (!value) return;
    if (isRange) {
      setValue(setValueBasedOnInputsWidth({
        from: value.from,
        to: value.to
      }));
    } else {
      setValue(setValueBasedOnInputsWidth({
        date: value
      }));
    }
  }, [value.from, value.to, value]);
  return children({
    value: preparedValue,
    refInput: ref
  });
};
ResponsiveValue.propTypes = {
  isRange: bool,
  children: func,
  value: oneOfType([string, object])
};
export default /*#__PURE__*/memo(ResponsiveValue);